export default __webpack_public_path__ + "static/media/Rectangle 224.be73464b.svg";